module.exports = __webpack_public_path__ + "static/media/bigwaster-logo.1257e6e7.png";